<template>
	<div class="col-12 col-lg-8">
		<div class="col-12 d-flex flex-column align-items-center">
			<img src="/svg/success_page_form.svg">
			<span class="title title-lg text-center">
				Рады приветствовать вас в Московской школе управления СКОЛКОВО!
			</span>
			<span class="text-center">
				В ближайшее время с вами свяжется менеджер программы
			</span>
		</div>
		<div v-if="order" class="list-titles my-4">
			<div
				v-if="order.data.products && order.data.products.length > 0"
				class="d-flex flex-lg-row flex-column text-center align-items-lg-end align-items-center"
			>
				<div>
					{{ order.data.products[0].title }}
				</div>
				<div class="border-dote d-none d-lg-flex" />
				<div class="title mb-0">
					{{ createMaskAmount(order.data.amount) }} ₽
				</div>
			</div>
			<div v-if="url" class="d-flex align-items-end mt-3">
				<span>Счет на оплату №123456-04</span>
				<div class="border-dote" />
				<span>
					<b-button
						variant="outline-primary"
						@click="downloadPdf(url, 'Счет на оплату')"
					>
						Скачать
					</b-button>
				</span>
			</div>
		</div>
		<div class="col-10 d-flex flex-column align-items-center ml-auto mr-auto">
			<div class="row">
				<!-- <a type="button" href="" class="col-12 col-lg success_page__card" @click="downloadPdf(agreement_url, 'Договор оферты')"> -->
				<a
					type="button"
					target="_blank"
					:href="urlAgreement"
					class="col-12 col-lg success_page__card"
				>
					<img src="/svg/form_offert.svg">
					<span class="description strong text-center mt-2">
						Скачайте и ознакомьтесь с договором оферты
					</span>
				</a>
				<a
					v-if="$auth.user"
					class="col-12 col-lg success_page__card ml-0 ml-lg-4 mt-2 mt-lg-0"
					href="/user/profile/?item=Documents"
				>
					<img src="/svg/form_documents.svg">
					<span class="description strong text-center mt-2">
						Проверьте загруженные документы в личном кабинете
					</span>
				</a>
			</div>
			<!-- <div class="row mt-2">
				<a href="/navigator/programmes/" target="_blank">
					<b-button variant="primary">
						Посмотреть интересные программы
					</b-button>
				</a>
			</div> -->
		</div>
	</div>
</template>

<script>
export default {
	name: 'SuccessStep',
	inject: ['person', 'loyalty', 'order'],
	data() {
		return {
			url: '',
			agreement_url: '',
		};
	},
	computed: {
		urlAgreement() {
			return this.order.unauthAgreements[0];
		},
	},
	async created() {
		await this.$api.getOrderCheckoutData(this.person.personData.order_hash).then((res) => {
			this.url = res.data.url;
		});
		[this.agreement_url] = this.person.personData.agreements;
	},
	methods: {
		async downloadPdf(linkPDF, name) {
			await this.$axios(linkPDF, { responseType: 'blob' })
				.then((response) => {
					const blob = new Blob([response.data], { type: 'application/pdf' });
					const link = document.createElement('a');
					link.href = URL.createObjectURL(blob);
					link.download = name;
					link.click();
					URL.revokeObjectURL(link.href);
				})
				.catch((error) => {
					console.error('Ошибка скачивания файла: ', error);
				});
		},
		createMaskAmount(value) {
			const price = parseFloat(value);
			return IMask.pipe(price.toString(), {
				mask: 'num',
				blocks: {
					num: {
						mask: Number,
						thousandsSeparator: ' ',
					},
				},
			});
		},
	},
};

</script>

<style scoped lang="scss">
@import '~/assets/styles/sk_variables';
@import "~/assets/styles/bootstrap/scss/functions";
@import "~/assets/styles/bootstrap/scss/variables";
@import "~/assets/styles/bootstrap/scss/mixins";

.border-dote {
	flex: 1 0;
	border-bottom: 2px dotted #000;
	height: 1em;
	margin: 0 .4em;
	margin-bottom: 6px;
}

.list-titles {
	font-size: 1.2rem;
}

.success_page__card {
	cursor: pointer;
	width: 19rem;
	padding: 1.5rem 2rem;
	border-radius: 1rem;
	background: #F4F4F4;

	display: flex;
	flex-direction: column;
	align-items: center;
	color: black;

	&:hover {
		background: #eeeeee;
	}
}
</style>
